class FilesModalController {
  constructor(
    $scope,
    $uibModalInstance,
    $q,
    translateFilter,
    documents,
    APIService,
    API_URL,
    LogService,
    StaffUserService
  ) {
    "ngInject";
    this.$scope            = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$q                = $q;
    this.translateFilter   = translateFilter;
    this.documents         = documents;
    this.APIService        = APIService;
    this.API_URL           = API_URL;
    this.LogService        = LogService;
    this.StaffUserService  = StaffUserService;
  }

  $onInit() {

  }

  set documents(documents) {
    this._documents = documents;
  }

  get documents() {
    return this._documents;
  }

  getFile(file) {
    this.StaffUserService.getFile(file.id).then(
      response => {
        let downloadLink = angular.element('<a></a>');
        downloadLink.attr('href', response.data.url);
        downloadLink[0].click();
      }
    ).catch(error => {
      this.LogService.warn('FILE Error:', error);
    });
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default FilesModalController;

